<form name="ShortCodeform"  style="margin-top:-1.5%;">

    <div class="container panel panel-default col-md-12" style="padding-left:0%;padding-right:0%;border-color:black;min-height:80vh;background-color: #f4f8f6;">
        <div class="panel panel-heading" style="padding-left:15px;padding-top: 0px;padding-bottom: 0px; background: linear-gradient(141deg, #460073 20%, #A100FF 65%); font-weight: bold; margin-top: -2.4%; color: white;">ShortCode Details</div>
        <div class="panel-body">
            <div class="activity-box" *ngIf="dataLoader" ><div class="loading-spiner"><img src="assets/img/loadingVer.gif" class="load"/></div></div>
            <div class="form-group row" style="margin-top:-2%;">
                <div class="col-sm-12">
                    <div>
                        <div class="col-sm-3 formdivcaptions " style="width:auto;margin-top:30px;">
                            <label style="color:black;font-weight:bold;margin-right:30px;">Device Type</label>
                            <label  *ngFor="let DeviceType of DeviceTypeList">
                                <input type="radio" name="radioDeviceType" value="{{DeviceType.name}}" (change) = "DeviceTypeEvent($event)" /><label>&nbsp;{{DeviceType.name}}&nbsp; </label>
                            </label>
                        </div>
                    </div>                                  
                </div>
                <div class="col-sm-12">
                    <div id="divShortcodeDetailsCommon" style="display:none">
                        <div class="col-sm-3 formdivcaptions ">
                            <label for="txtShortCode">Short Code</label>
                            <select class="form-control col-sm-4" id="txtShortCode" name="txtShortCode">
                                <option value="">&lt;--Select--&gt;</option>
                                <option *ngFor="let G of ShortCodes" value={{G.ShortCode}}>{{G.ShortCode}}</option>
                            </select>
                        </div>
                        <div class="col-sm-3 formDivdropDropdownControls">
                            <label for="drpstatus">Status</label>
                            <!-- <select class="form-control" id="drpstatus" name="drpstatus">
                                <option value="">&lt;--Select--&gt;</option>
                                <option value="Active">Active</option>
                                <option value="InActive">InActive</option>
                            </select> -->
                            <select class="form-control col-sm-4" id="drpstatus" name="drpstatus">
                                <option value="">&lt;--Select--&gt;</option>
                                <option *ngFor="let statusType of ShortCodeStatus">{{statusType.name}}</option>
                            </select>
                        </div> 
                        <!-- Facility Dropdown  -->
                        <!-- <div class="col-sm-3 formdivcaptions ">
                            <label>Facility</label>
                            <ng-multiselect-dropdown  placeholder ="Select" id="MultiFacilityList" name= "MultiFacilityList" [settings]="dropDownSettings" [data]="MultiFacilityList" [(ngModel)]="selectedFacility"></ng-multiselect-dropdown>
                        </div> -->
                        <div class="col-sm-3 formDivdropDropdownControls">
                            <label>Facility</label>
                            <ng-multiselect-dropdown class="dropdown-btn form-control" placeholder ="Select" id="MultiFacilityList" name="MultiFacilityList" [settings]="dropDownSettings" [data]="MultiFacilityList" [(ngModel)]="selectedFacility" ></ng-multiselect-dropdown>
                        </div>
                    </div>
                    <div class="col-sm-6 formdivcaptions" style="margin-top:2%;width: 90%;">
                        <div align="center" id="divShortcodeSubmit" style="display:none;">
                            <button type="submit" id="btnSearch" class="btn btn-default btn-group-sm Button1" (click)="ShowData()"><span class="fa fa-search-plus" aria-hidden="true"></span> Search</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <button type="submit" id="searchClear" class="btn btn-default btn-group-sm Button1" (click)="clear()"><span class="fa fa-close" aria-hidden="true"></span> Clear</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <button type="submit" id="btnDelete" class="btn btn-default btn-group-sm Button1" (click)="deleteshortcodeSelected()"><span class="fa fa-close" aria-hidden="true"></span> Delete</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <button type="submit" *ngIf="_Country=='India' && Device == 'Cisco'" id="btnExcelExport" class="btn btn-default btn-group-sm Button1" (click)="ExportToBulkExcel()"><span class="glyphicon glyphicon-export" aria-hidden="true"></span> Export to Excel</button>
                        </div>
                    </div>
                </div>

                <!-- Bulkupload -->
                <div id="ShortcodeBulkUpload" class="col-sm-12">
                    <hr style="margin-top: 15px;" id="uploadhr">
                    <form [formGroup]="addModifyHostNamesForm">
                        <div class="form-group row" id="divProjectDetailsCommonupload" style="display:none;">
                            <div class="col-sm-3">
                                <label for="UploadFile">For Short Codes Bulk Upload</label>
                            </div>
                            <div class="col-sm-8 ">
                                <!-- <div class="row ">
                                    <div class=" col-sm-5 ">
                                        <input type="file" formControlName="inputFile" style="height:33px;position:relative;" id="fileControl" placeholder="Upload Input" (change)="setFile($event)" />
                                    </div>
                                    <div class="col-sm-2">
                                        <a target="_blank" title="Download Bulk Template" (click)="DownloadPoCreateTemplate()" class="btn btn-info btn-mg glyphicon glyphicon-download-alt">
                                        </a>
                                    </div>
                                </div> -->
                                <div class="row ">
                                    <div class=" col-sm-5 ">
                                        <input type="file" formControlName="inputFile" style="height:33px;position:relative;" id="fileControl" placeholder="Upload Input" (change)="setFile($event)" />
                                    </div>
                                    <div class="col-sm-2">
                                        <a target="_blank" title="Download Bulk Template" (click)="DownloadPoCreateTemplate()" class="btn btn-info btn-mg glyphicon glyphicon-download-alt">
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <br>
                            <div class="row">
                                <!-- <div class="col-md-2 col-md-offset-5" class="text-center" style="margin-top: 20px;">
                                  
                                     <button type="submit" class="btn btn-default btn-group-sm Button1" (click)="addDetails()" #fileUpload >
                                        <span class="fa fa-check-circle" aria-hidden="true">
                                        </span> Upload File
                                     </button>
                                </div> -->
                                <div class="col-md-2 col-md-offset-5" class="text-center" style="margin-top: 20px;">
                                    <button type="submit" class="btn btn-default btn-group-sm Button1" (click)="addDetails()">
                                    <span class="fa fa-check-circle" aria-hidden="true">
                                    </span> Upload File
                                </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
       
        <div class="row table-responsive" id="divShortcodeDetails" style="display:none;">
            <div style="margin-left: 20px; margin-right: 20px;">
                
                <table id="ShortCodeDetail" class="table table-bordered" border="1" style="margin-left:1.5%;width:98%;font-size:13px;">
                    <thead style="color :white;background: #8064A2; background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                        <tr>
                            <th style="display:none">S.No</th>
                            <th><label for="selectedAll" style="text-align:center;">
                                <input type='checkbox' [(ngModel)]="selectedAll" [ngModelOptions]="{standalone: true}" (click)="checkAll($event.target.checked)" id="selectedAll" name="selectedAll" title="selectedAll"/>
                            </label> </th>
                            <th style="text-align: center;"></th>
                            <th style="text-align: center;width:50px;">Category Name</th>
                            <th style="text-align: center">Facility</th>
                            <th style="text-align: center">Short Code</th>
                            <th style="text-align: center">Phone Number</th>
                            <th style="text-align: center">WBSE</th>
                        </tr>
                    </thead>
                    
                    <tbody *ngFor="let shortcode of griddata">
                        <tr *ngIf="shortcode.Id != this.successfulData.selected.Id">

                            <td style="display:none;">{{shortcode.Id}}</td>
                            <td><label style="text-align :center;"><input type='checkbox' id="shortcodeRecords_{{shortcode.Id}}" name="check" [checked]="shortcode.checked" [(ngModel)]="shortcode.checked" [ngModelOptions]="{standalone: true}" title="shortcodeRecords_{{shortcode.Id}}" /></label> </td>
                            <td>
                                <img src="assets/img/Edit-icon.png" title="Edit" (click)="EditShortCode(shortcode)" />
                                <img src="assets/img/Delete.png" title="Delete" (click)="DeleteShortCode(shortcode)" />
                            </td>
                            <td><label>{{shortcode.CategoryName}}</label></td>
                            <td>{{shortcode.Facility}}</td>
                            <td>{{shortcode.ShortCode}}</td>
                            <td>{{shortcode.PhoneNumber}}</td>
                            <td>{{shortcode.WBS_Element}}</td>        
                        </tr>
                        <tr *ngIf="shortcode.Id ===  this.successfulData.selected.Id">
                            <td></td>
                            <td>
                                <img src="assets/img/Add.png" (click)="ShortCodeUpdate()" title="Update" />
                                <img src="assets/img/Cancel.jpg" (click)="reset()" title="Cancel" />
                            </td>
                            <td style="display:none;">{{successfulData.selected.Id}}</td>
                            
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-1.5%;margin-top:2%;" class="col-md-1">
                                     <span>*</span>
                                </div>
                                <input type="text" style="width:500px;" class="form-control" [(ngModel)]="successfulData.selected.CategoryName" maxlength="70" id="grdCatgName" name="grdCatgName" />
                            </td> 
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-5%;margin-top:2%;" class="col-md-1">
                                     <span>*</span>
                                </div>
                                <select id="grdFacility" name="grdFacility" [(ngModel)]="successfulData.selected.Facility" class="form-control ">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let f of Facilities" [ngValue]="f.Description">{{f.Description}}</option>
                                </select>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-6%;margin-top:2%;" class="col-md-1">
                                     <span>*</span>
                                </div>
                                <input type="text" class="form-control" [(ngModel)]="successfulData.selected.ShortCode" id="grdshortcode" name="grdshortcode" maxlength="6" (keypress)="validateNo($event)"/>
                            </td>                           
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-6%;margin-top:2%;" class="col-md-1">
                                     <span>*</span>
                                </div>
                                <input type="text" class="form-control" [(ngModel)]="successfulData.selected.PhoneNumber" id="grdPhoneNo" name="grdPhoneNo" maxlength="16" (keypress)="validateNumber($event)"   />
                            </td>      
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-7%;margin-top:2%;" class="col-md-1">
                                     <span>*</span>
                                </div>
                                <input type="text" class="form-control" [(ngModel)]="successfulData.selected.WBS_Element" id="grdwbse" name="grdwbse" maxlength="10" />
                            </td>                   
                        </tr>
                    </tbody>
                 
                    <tfoot>
                        <tr>
                            <td></td>
                            <td>
                                <button id="btnAddCountries" type="button" class="btn btn-default btn-group-sm Button2" (click)="ShortCodeAdd()">
                                    <span class="fa fa-check-circle" aria-hidden="true">
                                    </span> Add
                                </button>
                            </td>
                       
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-1.5%;margin-top:2%;" class="col-md-1">
                                    <span>*</span>
                                </div>
                                <input type="text" style="width:500px;" class="form-control" [(ngModel)]="ShortCodeDetails.CategoryName" maxlength="70" id="grdfcategoryname" name="grdfcategoryname" placeholder="Category Name" />
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-5%;margin-top:2%;" class="col-md-1">
                                    <span>*</span>
                                </div>
                                <select [(ngModel)] ="ShortCodeDetails.Facility" id="grdfFacility" name="grdfFacility" class="form-control " aria-labelledby="grdfFacility" >
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let f of Facilities">{{f.Description}}</option>
                                </select>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-6%;margin-top:2%;" class="col-md-1">
                                    <span>*</span>
                                </div>
                                <input type="text" class="form-control" [(ngModel)]="ShortCodeDetails.ShortCode" id="grdfshortcode" name="grdfshortcode" maxlength="6" (keypress)="validateNo($event)" placeholder="Shortcode"/>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-6%;margin-top:2%;" class="col-md-1">
                                    <span>*</span>
                                </div>
                                <input type="text" class="form-control" [(ngModel)]="ShortCodeDetails.PhoneNumber" id="grdfPhoneNo" name="grdfPhoneNo" maxlength="16" (keypress)="validateNumber($event)" placeholder="Phone Number"/>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-7%;margin-top:2%;" class="col-md-1">
                                    <span>*</span>
                                </div>
                                <input type="text" class="form-control" [(ngModel)]="ShortCodeDetails.WBS_Element" id="grdfwbse" name="grdfwbse" maxlength="10" placeholder="WBSE" />
                            </td>
                        </tr>                       
                        <tr>
                            <td colspan="11" style="text-align: center;">
                                <!-- pager -->
                                <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                                        <a><i (click)="setPage(1)" class="icon-fast-backward"></i>
                                        </a>
                                    </li>
                                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                                        <a><i (click)="setPage(pager.currentPage - 1)" class="icon-step-backward"></i></a>
                                    </li>
                                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                                        <a (click)="setPage(page)">{{page}}</a>
                                    </li>
                                    <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                        <a (click)="setPage(pager.startPage + 5)">...</a>
                                    </li>
                                    <li *ngIf="(pager.totalPages - pager.startPage) > 5" >
                                        <a (click)="setPage(pager.totalPages)">{{pager.totalPages}}</a>
                                    </li>
                                    
                                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                        <a><i (click)="setPage(pager.currentPage + 1)" class="icon-step-forward"></i></a>
                                    </li>
                                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                        <a><i (click)="setPage(pager.totalPages)" class="icon-fast-forward"></i></a>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    </tfoot>
                </table>  
            </div>
        </div>
        <div id="AlertForAccess" style="display:none;">
            <div class="row" style="padding-top:-20%">
                <div class="col-sm-12" style="margin-left:5%;">
                    <h4 style="color:red;">
                        Access Not Available.Please refer User Guidelines section for any access or tool issue.
                    </h4>
                </div>
            </div>
        </div>
    </div>
</form>
